import { useContext } from 'react';
import { DeepLinkProviderMissingError } from '../../errors';
import type { DeepLinkContextValue } from '../../types';
import { DeepLinkContext } from '../contexts/DeepLinkContext';

export const useDeepLinkContext = (): DeepLinkContextValue => {
    const deepLinkContext = useContext(DeepLinkContext);

    if (!deepLinkContext) {
        throw new DeepLinkProviderMissingError();
    }

    return deepLinkContext;
};
